import { HttpMethods } from "../configUtils";
import {
    formatHTTPGetUrl,
    getPreUrlByApiTag,
} from "./replaceUrlBydiffrentFetch";

/**
 *
 * java接口相关的http请求封装
 *
 * url：路径
 * params：参数
 *
 */
enum ErrorCode {
    Error = 500,
}

async function handleErrors(response: Response): Promise<any> {
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
    }

    const responseData = await response.json();

    if (responseData.code == ErrorCode.Error) {
        throw new Error(responseData);
    }
    return responseData;
}

class HandleJavaSearchFetch {
    static async request(
        url: string,
        method: HttpMethods,
        params: { [key: string]: any } = {},
        options: RequestInit = {},
    ): Promise<any> {
        let req_url = getPreUrlByApiTag(url, "api/javaSearch/");
        options.method = method;
        options.headers = {
            "Content-Type": "application/json",
            ...options.headers,
        };

        if (method === HttpMethods.GET) {
            req_url = formatHTTPGetUrl(req_url, params);
        } else {
            options.body = JSON.stringify(params);
        }

        try {
            const response = await fetch(req_url, options);
            return handleErrors(response);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }

    static async get(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaSearchFetch.request(
            url,
            HttpMethods.GET,
            params,
            options,
        );
    }

    static async post(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaSearchFetch.request(
            url,
            HttpMethods.POST,
            params,
            options,
        );
    }

    static async patch(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaSearchFetch.request(
            url,
            HttpMethods.PATCH,
            params,
            options,
        );
    }

    static async put(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaSearchFetch.request(
            url,
            HttpMethods.PUT,
            params,
            options,
        );
    }

    static async delete(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaSearchFetch.request(
            url,
            HttpMethods.DELETE,
            params,
            options,
        );
    }
}

export default HandleJavaSearchFetch;
